import React from "react";
import { useDarkMode } from "../../contexts/darkModeProvider";
import { Moon as MdDarkMode, Sun as MdLightMode } from "lucide-react";

/**
 * ThemeToggle component
 * Toggles between light and dark mode with icons
 * Allows users to explicitly select their preferred theme
 * Professional design with smooth transitions
 */
export function ThemeToggle() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <button
      onClick={toggleDarkMode}
      className={`
        p-2.5 rounded-lg transition-all duration-300 ease-in-out
        flex items-center justify-center gap-2
        ${
          isDarkMode
            ? "bg-slate-800 text-amber-400 hover:bg-slate-700 border border-slate-700"
            : "bg-slate-100 text-slate-700 hover:bg-slate-200 border border-slate-200"
        }
        focus:outline-none focus:ring-2 focus:ring-blue-50 focus:ring-offset-2
        dark:focus:ring-offset-slate-900
      `}
      title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDarkMode ? (
        <MdLightMode className="text-lg" />
      ) : (
        <MdDarkMode className="text-lg" />
      )}
    </button>
  );
}

export default ThemeToggle;
